import React from 'react'
import { connect } from 'react-redux'
import { GET_DATA_TABLE_BY_ID } from 'requests'
import { Spinner } from 'components/Loaders/Loaders'

class DataTable extends React.Component{
  state = {
    template: [
      {
        LABEL: (
          <span className="loading">
            Loading <Spinner size="small" color="#fff" />
          </span>
        ),
        id: 'loading'
      }
    ],
    rows: []
  }
  componentDidMount = () => {
    this.getDataTable()
  }
  getDataTable = () => {
    GET_DATA_TABLE_BY_ID(this.props.dataSrc, this.props.metadata, table => {
      // console.log(table);
      this.setState({template: table.TEMPLATE, rows: table.ROWS})
      this.props.onChange({template: table.TEMPLATE, rows: table.ROWS})
    })
  }
  render(){
    const { template, rows } = this.state;
    return(
      <div>
        <DumbTable template={template} rows={rows} />
      </div>
    )
  }
}
const ConnectedDataTable = connect(
  state => ({
    metadata: state.wizard.wizard.meta
  })
)(DataTable)

export default ConnectedDataTable

const DumbTable = ({template, rows}) => (
  <table className="form-table">
    <thead>
      <tr>
        {
          template.map(({LABEL}, i) => (
            <th key={i}>{LABEL}</th>
          ))
        }
      </tr>
    </thead>
    <tbody>
      {
        rows.map((row, i) => (
          <Row template={template} row={row} key={i} />
        ))
      }
    </tbody>
  </table>
)

const Row = ({row, template}) => (
  <tr>
    {
      template.map(({ID}) => (
        <td key={ID}>
          {row[ID]}
        </td>
      ))
    }
  </tr>
)



// WEBPACK FOOTER //
// ./src/components/Wizard2/fieldComponents/DataTable.js